import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AccessoriesService } from 'src/app/services/Accessories/accessory.service';
import { CachingService } from 'src/app/services/cache/caching.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { EventService } from 'src/app/services/Events/events.service';
import { ConfirmationModalComponent } from '../../confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'summary-breakup',
  templateUrl: './summary-breakup.component.html',
  styleUrls: ['./summary-breakup.component.scss'],
})
export class SummaryBreakupComponent implements OnInit {
  @Input() fromBreakup: boolean;
  accessoryPackages = [];
  modelSpecifications: any;
  extendedWarrantyCost: number;
  totalPrice: number;
  insurancePlanCost: number;
  mspCost: number;
  showMore = false;
  summaryDisclaimer =
    'Some information presented or used in the Drive-Away Price Calculator is sourced from third parties, and although every effort has been made to ensure that the information is accurate, absolute accuracy cannot be guaranteed. 1) Manufacturer’s Retail Price (including GST). 2) Dealer delivery charge (including GST) for Dealership specified, or, if no Dealership is specified, the average of dealer delivery charges (including GST) for the State or Territory of the post code entered. Individual Dealerships may charge more or less than the average dealer delivery charge. 3) Registration and/or Compulsory Insurance includes all relevant CTP and/or similar charges. For NSW and Queensland, where CTP varies according to insurer and nature of owner, the amount used for the calculation is based on rates charged by NRMA for a 40 year old male with a good driving record. Where a National Driveaway Offer Price is shown onroad costs are included. However when additional accessories are added to the National Driveaway Offer during the configuration process, additional Luxury Car Tax and Stamp Duty fees will apply.  Consult with your Jeep Dealer for a final price.';
  constructor(
    private events: EventService,
    private modalController: ModalController,
    private cachingService: CachingService,
    public accessoriesService: AccessoriesService,
    public globalService: GlobalService
  ) {}

  ngOnInit() {
    this.events.subscribe('events', (data) => {
      this.subscribeToEvents(data);
    });

    try {
      this.getSpecifications();
    } catch (err) {
      console.error(err);
    }
  }

  subscribeToEvents(data) {
    let key = Object.keys(data)[0];
    switch (key) {
      case 'updatedWarrantyCost':
        this.getExtendedWarrantyCost();
        break;
      case 'updatedInsuranceCost':
        this.getInsuranceCost();
        break;
      case 'updatedMSPCost':
        this.getMSPCost();
        break;
      case 'updatedTotalTaxPrices':
        this.getTotalPrice();
        this.getSpecifications();
        break;
      default:
        break;
    }
  }

  async getSpecifications() {
    let config = await this.cachingService.getDataFromSession('config');
    let modelSelected = await this.cachingService.getDataFromSession(
      'modelSelected'
    );
    this.accessoryPackages = config.addedAccessoriesPacks;

    this.modelSpecifications = [
      {
        label: 'MODEL',
        value: modelSelected.model_name,
        display: true,
      },
      {
        label: 'VARIANT',
        value: config.selectedVariant.variant_name,
        display: true,
      },
      {
        label: 'COLOR',
        value: config.colorSelected.color_name,
        display: true,
      },
      {
        label: 'TRIM',
        value: config.trimSelected?.color_name,
        display: config.trimSelected ? true : false,
      },
      {
        label: 'TRANSMISSION & DRIVE',
        value:
          config.selectedVariant.transmission_code +
          ' ' +
          config.selectedVariant.drive,
        display: true,
      },
      {
        label: 'Drive Away Price',
        value: this.globalService.currencyFormatter(
          this.globalService.selectedConfigPrice?.drive_away_price +
            this.accessoriesService.updateAccessoryPrice().packs
        ),
        class: 'bold',
        display: true,
      },
      {
        label: 'Vehicle Price',
        value: this.globalService.currencyFormatter(
          this.globalService.selectedConfigPrice?.vehicle_price
        ),
        display: true,
      },
      {
        label: 'Dealer Delivery',
        value: this.globalService.currencyFormatter(
          this.globalService.selectedConfigPrice?.dealer_delivery
        ),
        display: true,
      },
      {
        label: 'Pack Price',
        value: this.globalService.currencyFormatterZero(
          this.accessoriesService.updateAccessoryPrice().packs
        ),
        display: true,
      },
      {
        label: 'Paint cost',
        value: this.globalService.currencyFormatterZero(
          config.colorSelected?.paint_cost
        ),
        display: true,
      },
      {
        label: 'GOVERNMENT CHARGES:',
        value: '',
        class: 'bold',
        display: true,
      },
      {
        label: 'Luxury car tax',
        value: this.globalService.currencyFormatterZero(
          this.globalService.selectedConfigPrice &&
            this.globalService.selectedConfigPrice['government charges']
              ?.luxury_car_tax
        ),
        display: true,
      },
      {
        label: 'Registration',
        value: this.globalService.currencyFormatterZero(
          this.globalService.selectedConfigPrice &&
            this.globalService.selectedConfigPrice['government charges']
              ?.registration
        ),
        display: true,
      },
      {
        label: 'Compulsory Insurance',
        value: this.globalService.currencyFormatterZero(
          this.globalService.selectedConfigPrice &&
            this.globalService.selectedConfigPrice['government charges']
              ?.compulsory_insurance
        ),
        display: true,
      },
      {
        label: 'Stamp duty',
        value: this.globalService.currencyFormatterZero(
          this.globalService.selectedConfigPrice &&
            this.globalService.selectedConfigPrice['government charges']
              ?.stamp_duty
        ),
        display: true,
      },
    ];

    this.getExtendedWarrantyCost();
    this.getInsuranceCost();
    this.getMSPCost();
  }

  async getTotalPrice() {
    let config = await this.cachingService.getDataFromSession('config');
    if (config.colorSelected?.total_price == 0) {
      this.totalPrice = 0;
      return;
    } else {
      this.totalPrice =
        this.globalService.selectedConfigPrice?.drive_away_price; // changed as per aus pricing
      // this.accessoriesService.updateAccessoryPrice().total +
      // config.colorSelected?.total_price +
      // this.extendedWarrantyCost +
      // this.insurancePlanCost +
      // this.mspCost;
    }
  }

  async getExtendedWarrantyCost() {
    let extendedWarranty = await this.cachingService.getDataFromSession(
      'extendedWarranty_details'
    );
    if (extendedWarranty?.warrantyPrice) {
      this.extendedWarrantyCost = extendedWarranty.warrantyPrice;
    } else {
      this.extendedWarrantyCost = 0;
    }
    this.getTotalPrice();
  }
  async getInsuranceCost() {
    let insurancePlan = await this.cachingService.getDataFromSession(
      'insurancePlan_details'
    );
    if (insurancePlan?.insuranceCost) {
      this.insurancePlanCost = insurancePlan.insuranceCost;
    } else {
      this.insurancePlanCost = 0;
    }
    this.getTotalPrice();
  }

  async getMSPCost() {
    let amc_details = await this.cachingService.getDataFromSession(
      'amc_details'
    );
    if (amc_details?.AnnualMaintenanceContractPrice) {
      this.mspCost = amc_details.AnnualMaintenanceContractPrice;
    } else {
      this.mspCost = 0;
    }
    this.getTotalPrice();
  }

  async removePackConfirmation(pack) {
    const modal = await this.modalController.create({
      component: ConfirmationModalComponent,
      componentProps: {
        msg: {
          header: 'REMOVE_PACK.HEADER',
          content: 'REMOVE_PACK.CONTENT',
          cancelText: 'REMOVE_PACK.CANCEL',
          confirmText: 'REMOVE_PACK.CONFIRM',
        },
      },
      backdropDismiss: false,
      cssClass: 'confirmation-modal',
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    data ? this.removePack(pack) : null;
  }
  removePack(pack) {
    this.accessoriesService.removePack(pack);
    this.accessoryPackages = this.globalService.addedAccessoriesPacks;
    this.getTotalPrice();
  }
}
